'use client';

import { c as _c } from "react/compiler-runtime";
import Modal, { ModalBackdrop, ModalPanel } from '@/ui/Modal';
import Skeleton from '@/ui/Skeleton';
import { Content, Header, Main } from '@/ui/Layout';
import NavButtonSkeleton from '@/components/NavButton/NavButton.skeleton';
import useOptimisticModal from './useOptimisticModal';
const OptimisticInterceptionModal = () => {
  const $ = _c(16);
  const [modalState, setModalState] = useOptimisticModal();
  const open = modalState ? !modalState?.closed : false;
  let t0;
  if ($[0] !== modalState || $[1] !== setModalState) {
    t0 = () => {
      setModalState({
        ...(modalState ?? {}),
        closed: true
      });
    };
    $[0] = modalState;
    $[1] = setModalState;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const t1 = !modalState?.closed && (modalState?.appear ?? true);
  const t2 = modalState?.withoutBackdrop;
  let t3;
  if ($[3] !== modalState?.withoutBackdrop) {
    t3 = !modalState?.withoutBackdrop && <ModalBackdrop />;
    $[3] = modalState?.withoutBackdrop;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = modalState?.variant ?? "fullscreen";
  const t5 = modalState?.className;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Main><Content><Header><NavButtonSkeleton /><Skeleton className="h-8 w-56 rounded-xs" /></Header></Content></Main>;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t4 || $[7] !== t5) {
    t7 = <ModalPanel variant={t4} className={t5}>{t6}</ModalPanel>;
    $[6] = t4;
    $[7] = t5;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== open || $[10] !== t0 || $[11] !== t1 || $[12] !== t2 || $[13] !== t3 || $[14] !== t7) {
    t8 = <Modal className="isolate z-999" open={open} onClose={t0} appear={t1} nonBlocking={t2}>{t3}{t7}</Modal>;
    $[9] = open;
    $[10] = t0;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
};
export default OptimisticInterceptionModal;